import React from "react";
import * as styles from "./MetricsStrip.module.scss";

export interface MetricItem {
  number: string;
  label: string;
}

type Props = {
  items: MetricItem[];
  bgColor?: string;
  numColor?: string;
};

export const MetricsStrip: React.FC<Props> = ({
  items,
  bgColor = "#1A1A1A",
  numColor = "#D0FF37",
}) => {
  return (
    <div className={styles.strip} style={{ background: bgColor }}>
      {items.map((item, i) => (
        <div key={i} className={styles.cell}>
          <span className={styles.number} style={{ color: numColor }}>
            {item.number}
          </span>
          <span className={styles.label}>{item.label}</span>
        </div>
      ))}
    </div>
  );
};
